export const pending = 1;
export const processing = 2;
export const offTrack = 3;
export const onTrack = 4;
export const goalReached = 5;
export const completed = 6;
export const expired = 7;

export const statusOptions = [
    {
        value: 'current',
        label: 'Current',
        nested: [
            {
                value: goalReached,
                label: 'Goal Reached',
            },
            {
                value: onTrack,
                label: 'On Track',
            },
            {
                value: offTrack,
                label: 'Off Track',
            },
            {
                value: processing,
                label: 'Processing',
            },
        ],
    },
    {
        value: 'past',
        label: 'Past',
        nested: [
            {
                value: completed,
                label: 'Completed',
            },
            {
                value: expired,
                label: 'Expired',
            },
        ],
    },
    {
        value: `future`,
        label: 'Future',
        nested: [
            {
                value: pending,
                label: 'Pending',
            },
        ],
    },
];
